import ScrollHint from 'scroll-hint';
// import "scroll-hint/css/scroll-hint.css";

const init = () => {
  new ScrollHint('.js-scrollable');
}

export {
  init
}